import { getCurrentInstance } from "vue";

import store from "@/store";

export function useStore() {
  return getCurrentInstance()!.proxy.$store as typeof store;
}
